export function startsWithSeven(str: string) {
    const regex = /^7/;
    return regex.test(str);
}
